<template>
	<div>		
		<div class="actDiv" title="扣费统计">
			<label>小区</label>
			<a-select style="width:9rem; margin: 0 0.625rem;font-size: 0.6875rem;" v-model="theNeighbor" placeholder="请选择小区"
				 label-in-value option-filter-prop="children"  :filter-option="filterOption" show-search @change="getDateList">
				<a-select-option v-for="(item,index) in searchneighborList" :key="item.pId" :value="item.pId">
					{{item.neighborName}}
				</a-select-option>
			</a-select>
			<label>结算</label>
			<a-select style="width:9rem; margin: 0 0.625rem;font-size: 0.6875rem;" v-model="theSettle" label-in-value
				option-filter-prop="children"  :filter-option="filterOption" show-search>
				<a-select-option v-for="(item,index) in dateList" :key="item.PID" :value="item.PID">
					{{getTime(item.StartTime)}}
				</a-select-option>
			</a-select>
			<a-select style="width:9rem; margin: 0 0.625rem;font-size: 0.6875rem;" v-model="searchmodel.pre" :filter-option="false" show-search>
				<a-select-option v-for="(item,index) in payList" :value="item.value">{{item.label}}</a-select-option>
			</a-select>
			<a-button size="small" icon="search"   @click="query" style="margin: 0 0.625rem;">查找</a-button>
			<a-button size="small" icon="printer"   @click="print" style="margin: 0 0.625rem;">打印</a-button>
			<a-button size="small" icon="export"   @click="downloadExcel" style="margin: 0 0.625rem;" :loading="exportLoading">导出Excel</a-button>
			<a-dropdown placement="bottomCenter" :disabled="list.length==0">
				<a-button  size="small">按阶梯过滤</a-button>
				<a-menu slot="overlay" @click="queryByJT">
					<a-menu-item  v-for="(item,index) in jList" :key="item.value">
						{{item.name}}
					</a-menu-item>
				</a-menu>
			</a-dropdown>
		</div>	
		<vxe-table  align="center" :data="list"  border height="300"  ref="mTable" show-overflow="title" size="mini"
						  resizable highlight-hover-row :loading="loading"  row-id="pid"  :cell-style="cellClassName">
							<vxe-table-column type="seq" width="60"></vxe-table-column>
							<vxe-table-column title="用户号" field="c_num" ></vxe-table-column>
							<vxe-table-column title="用户名" field="CustomerName"></vxe-table-column>
							<vxe-table-column title="地址" field="customerAddr" ></vxe-table-column>
							<vxe-table-column title="手机" field="CustomerMobile"></vxe-table-column>
							<vxe-table-column title="余额" field="CustomerBalance"></vxe-table-column>
							<vxe-table-column title="余额阀值" field="warnThre"></vxe-table-column>
							<vxe-table-column title="单价" field="pricekindname"></vxe-table-column>
							<vxe-table-column title="换表用量" field="usedread"></vxe-table-column>
							<vxe-table-column title="扣费读数" field="lastderead"></vxe-table-column>
							<vxe-table-column title="阶梯起始" field="destartread"></vxe-table-column>
							<vxe-table-column title="表状态" field="meterState" :formatter="getMeterState"></vxe-table-column>
							<vxe-table-column title="表读数" field="meterread"></vxe-table-column>
							<vxe-table-column title="换表底数" field="changeend"></vxe-table-column>
							<vxe-table-column title="抄表时间" field="meterreadtime" :formatter="getTimeFormatter"></vxe-table-column>
							<vxe-table-column title="用量" field="yl">
								<template #default="{ row }">
									<span>
										{{getYL(row)}}
									</span>
								</template>
							</vxe-table-column>
							<vxe-table-column title="阶梯" field="formula" ></vxe-table-column>
							<vxe-table-column title="减免" field="minusderead"></vxe-table-column>
							<vxe-table-column title="转到虚表" field="tovirtual" ></vxe-table-column>
							<vxe-table-column title="扣费前" field="fromMoney"></vxe-table-column>
						    <vxe-table-column title="扣费金额" field="demoney"></vxe-table-column>
							<vxe-table-column title="扣费后" field="toMoney"></vxe-table-column>
	    </vxe-table>	
		<a-row :gutter="5" style="margin-top: 1.25rem;">
			<a-col :span="6">
				<label style="font-size: 0.75rem;">用量统计</label>
				<a-table size="small" :columns="settledYLcolumns" :data-source="getSettledYL" bordered
					:rowKey="settledYLcolumns.pricekindname" :pagination="false" :loading="loading">
				</a-table>
			</a-col>
			<a-col :span="6">
				<label style="font-size: 0.75rem;">小区扣费统计</label>
				<a-table size="small" :columns="settleLogcolumns" :data-source="settleLog" bordered
					:rowKey="settleLogcolumns.toMoney" :pagination="false" :loading="loading">
				</a-table>
				
			</a-col>
			<a-col :span="6">
			<label style="font-size: 0.75rem;">小区金额</label>
			<a-table size="small" :columns="neighborcolumns" :data-source="neighborBalance" bordered
				:rowKey="neighborcolumns.pre" :pagination="false" :loading="loading">
			</a-table>
			</a-col>
			
			<a-col :span="6">
				<label style="font-size: 0.75rem;">阶梯统计</label>
				<a-table size="small" :columns="listjietiylcolumns" :data-source="listjietiyl" bordered
					:rowKey="listjietiylcolumns.name" :pagination="false" :loading="loading">
				</a-table>
			</a-col>				
		</a-row>
	</div>
</template>

<script>
	export default {
		data() {
			const settledYLcolumns = [{
					title: '单价',
					dataIndex: 'pricekindname',
					width: 80,
					className:'v-cell',
					align:'center',
				},
				{
					title: '用量',
					dataIndex: 'yl',
					width: 80,
					className:'v-cell',
					align:'center',
				},
				{
					title: '扣费金额',
					dataIndex: 'demoney',
					width: 80,
					className:'v-cell',
					align:'center',
				}
			];
			const settleLogcolumns = [{
					title: '扣费前',
					dataIndex: 'fromMoney',
					width: 80,
					className:'v-cell',
					align:'center',

				},
				{
					title: '扣费后',
					dataIndex: 'toMoney',
					width: 80,
					className:'v-cell',
					align:'center',
				}
			];
			const neighborcolumns = [{
					title: '付费方式',
					dataIndex: 'pre',
					width: 80,
					className:'v-cell',
					align:'center',
				},
				{
					title: '余额',
					dataIndex: 'balance',
					width: 80,
					className:'v-cell',
					align:'center',
				}
			];
			const listjietiylcolumns = [{
					title: '阶梯',
					dataIndex: 'name',
					width: 80,
					className:'v-cell',
					align:'center',
				},
				{
					title: '用量',
					dataIndex: 'yl',
					width: 80,
					className:'v-cell',
					align:'center',
				},
				{
					title: '金额',
					dataIndex: 'price',
					width: 80,
					className:'v-cell',
					align:'center',
				}
			];
			return {
				settleLogcolumns,
				neighborcolumns,
				settledYLcolumns,
				listjietiylcolumns,
				exportLoading:false,
				loading: false,
				selectedRowKeys: [],
				searchmodel: {
					n_id: 0,
					pre: 1,
					paytype: 2,
					settle_id: null,
				},
				theNeighbor:undefined,
				theSettle:undefined,
				dateList: [],
				settleLog: [],
				neighborBalance: [],
				getSettledYL: [],
				listjietiyl: [],
				list: [],
				tempList:[],
				searchneighborList: [],
				payList: [{
						value: 1,
						label: "预付费"
					},
					{
						value: 0,
						label: "后付费"
					},
					{
						value: 2,
						label: "全部"
					},
				],
				payTypeList: [{
						value: 1,
						label: "支付宝缴费"
					},
					{
						value: 0,
						label: "营业厅缴费"
					},
					{
						value: 2,
						label: "请选择"
					},
				],
				jList:[
					{name:'只看一阶',value:1},
					{name:'只看二阶',value:2},
					{name:'只看三阶',value:3},
					{name:'只看二阶和三阶',value:4},
					{name:'查看全部',value:5},
				],
			}
		},

		methods: {
			queryByJT:function(e){
				let type = e.key;
				let theList = [];
				switch(type){
					case 1:{
						for(var i=0;i<this.tempList.length;i++){
							let item = this.tempList[i];
							let formula = item.formula;
							if(formula){
								let strArray = formula.split("-");
								if(strArray.length>0){
									let f = strArray[0];
									let s = strArray[1];
									let t = strArray[2];
									//一阶大于0，二阶三阶等于0
									if(Number(f)>0  && Number(s) == 0 && Number(t)==0){
										theList.push(item);
									}
								}
							}
						}
					}
					break;
					case 2:{
						for(var i=0;i<this.tempList.length;i++){
							let item = this.tempList[i];
							let formula = item.formula;
							if(formula){
								let strArray = formula.split("-");
								if(strArray.length>0){
									let f = strArray[0];
									let s = strArray[1];
									let t = strArray[2];
									//二阶大于0,三阶等于0
									if( Number(s) > 0){
										theList.push(item);
									}
								}
							}
						}
					}
					break;
					case 3:{
						for(var i=0;i<this.tempList.length;i++){
							let item = this.tempList[i];
							let formula = item.formula;
							if(formula){
								let strArray = formula.split("-");
								if(strArray.length>0){
									let f = strArray[0];
									let s = strArray[1];
									let t = strArray[2];
									//一阶等于0，二阶大于0，三阶等于0
									if(Number(t)>0){
										theList.push(item);
									}
								}
							}
						}
					}
					break;
					case 4:{
						for(var i=0;i<this.tempList.length;i++){
							let item = this.tempList[i];
							let formula = item.formula;
							if(formula){
								let strArray = formula.split("-");
								if(strArray.length>0){
									let f = strArray[0];
									let s = strArray[1];
									let t = strArray[2];
									//二阶或三阶大于0
									if(Number(s)>0 && Number(t)>0){
										theList.push(item);
									}
								}
							}
						}
					}
					break;
					case 5:{
						theList = this.tempList;
					}
					break;
				}
				this.list = theList;
			},
			downloadExcel:function(){
				this.exportLoading = true;
				let url = this.Api.getLastUrl(this.Api.STATIS_DEDUCT_EXPORT_URL);
				let param = {neighborId:this.searchmodel.n_id,settle_id:this.searchmodel.settle_id,pre:this.searchmodel.pre};
				this.Api.fetchPostFile(url,param).then((res)=>{
					this.exportLoading = false;
					let blob = new Blob([res.data]);
					let downloadElement = document.createElement('a')
					let href = window.URL.createObjectURL(blob); //创建下载的链接
					downloadElement.href = href;
					downloadElement.download = this.theNeighbor.label+'扣费统计.xlsx'; //下载后文件名
					document.body.appendChild(downloadElement);
					downloadElement.click(); //点击下载
					document.body.removeChild(downloadElement); //下载完成移除元素
					window.URL.revokeObjectURL(href); //释放blob对象
				}).catch((error)=>{
					this.exportLoading = false;
					console.log(error);
				});
			},
			scrollSome:function(){
				this.$refs.mTable.refreshScroll();
			},
			filterOption(input, option) {
				return (option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0);
			},
			getMeterState({cellValue}){
				return this.Config.getValueByNameFromList(cellValue,this.Config.getMeterStateList());
			},
			getTimeFormatter({cellValue}){
				if(cellValue == null){
					return "";
				}else{
					let date = new Date(cellValue);
					return this.Config.formatDate(date);
				}
			},
			cellClassName({ row, rowIndex, column }){
				let style = null;
				if(column.property == 'CustomerBalance'){
					if(row.CustomerBalance<=0){
						 style =  {
							 backgroundColor: '#ffee00',
							 color: '#ff0000'
						 }
					}
				} else if(column.property == 'meterState'){
					if(row.meterState !=1){
						style = {
								'color':'#ff0000',
						}
					}
				}else{
					style = {
							'color':'#000',
					}	
				}	
				return style;
			},
			getYL(row) {
				if (row.changeend > 0) {
					return row.meterread + row.changeend - row.lastderead;
				} else {
					return row.meterread - row.lastderead;
				}
			},
			getDateList(value) {
				this.searchmodel.n_id = value.key;
				this.searchmodel.settle_id = null;
				this.dateList = [];
				this.theSettle = undefined,
				this.querylistsettled();
			},
			getTime: function(actionTime) {
				let date = new Date(actionTime);
				return this.Config.formatDate(date);
			},
			print: function() {
				let url = this.Api.getLastUrl(this.Api.STATIS_Settlelog_Print_URL);
				if (this.searchmodel.n_id == 0) {
					this.$message.info("请选择小区");
					return;
				}
				if (this.theNeighbor == undefined) {
					this.$message.info("请选择小区");
					return;
				}
				if(this.theNeighbor!=undefined){
					this.searchmodel.n_id = this.theNeighbor.key;
					this.searchmodel.n_name = this.theNeighbor.label;
				}else{
					this.searchmodel.n_name = '';
				}
				if(this.theSettle!=undefined){
					this.searchmodel.settle_id = this.theSettle.key;
					this.searchmodel.settle_time = this.theSettle.label;
				}
				if (this.searchmodel.settle_id == null) {
					this.$message.info("请选择结算");
					return;
				}
				let userInfo = this.Config.getUserLocal();
				window.open(url + "?n_id=" + this.searchmodel.n_id + "&UserId=" + userInfo.pId +"&n_name="+this.searchmodel.n_name+
					"&pre=" + this.searchmodel.pre + "&settle_id=" + this.searchmodel.settle_id+ "&settle_time=" + this.searchmodel.settle_time, "_blank");
			},
			query: function() {
				let url = this.Api.getLastUrl(this.Api.STATIS_List_Settled_URL);
				if (this.searchmodel.n_id == 0) {
					this.$message.info("请选择小区");
					return;
				}
				if (this.theNeighbor == undefined) {
					this.$message.info("请选择小区");
					return;
				}
				if(this.theSettle!=undefined){
					this.searchmodel.settle_id = this.theSettle.key;
					this.searchmodel.settle_time = this.theSettle.label;
				}
				if (this.searchmodel.settle_id == null) {
					this.$message.info("请选择结算");
					return;
				}
				this.loading = true;
				this.Api.fetchPost(url, this.searchmodel).then((data) => {
					this.loading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if (code == this.Api.HTTP_OK_CODE) {
						this.list = result.logAll;
						this.tempList = result.logAll;
						this.settleLog = result.settleLog;
						this.neighborBalance = result.neighborBalance;
						this.getSettledYL = result.getSettledYL;
						this.listjietiyl = result.listjietiyl;
					} else {
						this.$message.error(msg);

					}
				}).catch((error) => {
					console.log(error);
					this.loading = false;
				});
				

			},
			queryNeighbors: function() {
				let url = this.Api.getLastUrl(this.Api.NEIGHBOR_SEARCH_LIST_URL);
				this.Api.fetchPostWithForm(url).then((data) => {
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if (code == this.Api.HTTP_OK_CODE) {
						this.searchneighborList = result;
					} else {
						this.$message.error(msg);
					}
				}).catch((error) => {
					console.log(error);
				});
			},
			querylistsettled: function() {
				let url = this.Api.getLastUrl(this.Api.STATIS_List_Settle_Log_URL);
				let n_id = this.searchmodel.n_id;
				this.Api.fetchPost(url, {
					n_id,
					n_id
				}).then((data) => {
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if (code == this.Api.HTTP_OK_CODE) {
						this.dateList = result;
					} else {
						this.$message.error(msg);
					}
				}).catch((error) => {
					console.log(error);
				});
			},
		},
		created() {
			this.queryNeighbors();
		},
	}
</script>

<style>
</style>
